import { render, staticRenderFns } from "./EditSpacesIcon.vue?vue&type=template&id=4c02d90d&"
import script from "./EditSpacesIcon.vue?vue&type=script&lang=ts&"
export * from "./EditSpacesIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports